import {getAboutIndex} from '@/api'

const actions = {
	async getAboutData({commit}){
		let res = await getAboutIndex()
			commit('SAVE_ABOUT_DATA',res)
	}
}

const mutations = {
	SAVE_ABOUT_DATA(state,data){
		state.introduction = data.data.introduction
		state.development = data.data.development
		state.module = data.data.module
	}
}

const state = {
	introduction:[[],[]],
	development:[],
	module:[],
}

const getters = {
	
}

export default {
	actions,
	mutations,
	state,
	getters
}